<template>
    <div>
        <div class="pageContent" v-if="type === 'cad'">
            <div class="pageContent-in">
                <main class="pageContent-main">
                    <div class="textcontent">
                        <h1 class="page-title">CAD výkresy</h1>
                    </div>
                </main>
            </div>
        </div>
        <div class="pagePart-in view-mobile-nosides">
            <breadcrumb></breadcrumb>
            <div :class="{'documentation': true, 'documentation--default': !getOpenedCategories().length}">
                <div id="documentsSlider">
                    <div class="documentation__defaultState" v-if="!getOpenedCategories().length">
                        <div class="documentation__defaultStateInner" v-if="type === 'documents'">
                            <div class="documentation__defaultStateIcon"></div>
                            <h3>Dokumentace ke stažení</h3>
                            <p>Vyberte kategorii, kterou si přejete zobrazit</p>
                        </div>
                        <div class="documentation__defaultStateInner documentation__defaultStateInner--cad"
                             v-if="type === 'cad'">
                            <div class="documentation__defaultStateIcon"></div>
                            <h3>Dokumentace ke stažení</h3>
                            <p>Vyberte kategorii, kterou si přejte zobrazit<br>anebo vyhledejte výkres podle čísla
                                konstrukce</p>
                            <download-search-input/>
                        </div>
                    </div>
                    <download-category-list :children="rootCategories"/>
                    <download-category-list :key="categorySlug" :children="getCategoriesByParent(categorySlug)"
                                            v-for="categorySlug in getOpenedCategories()"/>
                    <download-main-list/>
                    <vks-banner v-if="isVKSBook"/>
                    <pricelist-banner v-if="isPricelist"/>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div class="siteFooterBeforeSpace"></div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import last from 'lodash/last';
    import isUndefined from 'lodash/isUndefined';
    import filter from 'lodash/filter';
    import DownloadCategoryList from './CategoryList';
    import {moveWithSlider, setCategoryListCommonHeight, setHeadline, isMobileView} from './helper/slider';
    import {SLUG_SEPARATOR} from './const';
    import DownloadMainList from './MainList';
    import VksBanner from './VksBanner';
    import DownloadSearchInput from './SearchInput';
    import Breadcrumb from "./Breadcrumb";
    import PricelistBanner from "./PricelistBanner.vue";

    export default {
        name:       'DownloadCategory',
        components: {
          PricelistBanner,
            Breadcrumb,
            DownloadSearchInput,
            DownloadMainList,
            DownloadCategoryList,
            VksBanner
        },
        computed:   {
            ...mapGetters('cad', ['rootCategories', 'categories', 'type']),

          isVKSBook() {
            let slug = this.getSlug()

            if (isUndefined(slug)) {
              return false;
            }

            slug = slug.split(SLUG_SEPARATOR)[1];

            return slug === 'velka-kniha-sadrokartonu';
          },
          isPricelist() {
            let slug = this.getSlug()

            if (isUndefined(slug)) {
              return false;
            }

            return slug === 'cenik';
          },
        },
        data() {
            return {
                rendered: false,
            }
        },
        mounted() {
            this.calculateBehavior();
            this.rendered = true;
        },
        updated() {
            this.calculateBehavior();
        },
        methods:    {
            getSlug() {
                return this.$route.params.slug;
            },
            getOpenedCategories() {
                const slug = this.getSlug()
                if (isUndefined(slug)) {
                    return [];
                }
                return slug.split(SLUG_SEPARATOR);
            },
            getCategoriesByParent(slug) {
                return filter(this.categories, category => category.parentSlug === slug);
            },
            getCategoryBySlug(slug) {
                const categories = filter(this.categories, category => category.slug === slug);
                if (categories.length) {
                    return categories[0];
                }
                return null;
            },
            isMobileView() {
                return isMobileView();
            },

            calculateBehavior() {
                const numberOfOpenedCategories = this.getOpenedCategories().length;
                const parameters = { numberOfOpenedCategories: numberOfOpenedCategories };
                const defaultHeadline = this.type === 'cad' ? 'CAD výkresy' : 'Ke stažení';

                moveWithSlider(parameters);
                setCategoryListCommonHeight();

                if (isMobileView()) {
                    const currentCategorySlug = last(this.getOpenedCategories());
                    const category = this.getCategoryBySlug(currentCategorySlug);
                    if (null !== category) {
                        const { name } = category;
                        setHeadline(name);
                    } else {
                        setHeadline(defaultHeadline);
                    }
                } else {
                    const openedCategories = this.getOpenedCategories();
                    if (openedCategories.length) {
                        const firstCategorySlug = openedCategories[0];
                        const category = this.getCategoryBySlug(firstCategorySlug);
                        const { name } = category;
                        setHeadline(name);
                    } else {
                        setHeadline(defaultHeadline);
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cad/Category.vue